'use client';

import { IndentPlugin } from '@platejs/indent/react';
import { KEYS } from 'platejs';

/** Indent support scoped to field-tier block types only. */
export const FieldIndentKit = [
  IndentPlugin.configure({
    inject: {
      targetPlugins: [...KEYS.heading, KEYS.p, KEYS.blockquote, KEYS.img],
    },
    options: {
      offset: 24,
    },
  }),
];
